import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';

const SubTotalField: FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem } = props;

  const isLb = useMemo(() => String(dataItem?.uom).toLowerCase() === 'lb', [dataItem?.uom]);
  const { value } = useDelayedInputOnchange(props);
  const formatted = '$' + Number(value).toFixed(isLb ? 3 : 2);

  return (
    <GridCellBase {...props} title={formatted}>
      <span>{formatted}</span>
    </GridCellBase>
  );
};

export default SubTotalField;
